// extracted by mini-css-extract-plugin
export default {"page":"page_page__LgHdJ","main":"page_main__nI53e","primary":"page_primary__Ykp5G","secondary":"page_secondary__Vs593","footer":"page_footer__LXrQq"};